<template>
  <div class="tag-input-component form-group">
    <label for="input-tag">{{ label }}</label>
    <div class="input-tag">
      <button
        v-for="(opt, index) in added"
        :key="index"
        type="button"
        class="btn btn-primary btn-sm px-3 py-2 mx-3"
        @click="removeTag(opt)"
      >
        {{ opt }} <i class="icon-x ml-3"></i>
      </button>
      <input
        id="input-tag"
        class="flex-fill p-2"
        type="text"
        v-model="innerValue"
        :placeholder="placeholder"
        @blur="onSubmit"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: "Digite o texto"
    },
    placeholder: {
      type: String,
      default: "Digite o texto"
    }
  },
  data() {
    return {
      added: this.value,
      innerValue: ""
    };
  },
  watch: {
    added(newVal) {
      this.$emit("input", newVal);
    },
    value(v) {
      this.added = v;
    }
  },
  methods: {
    onSubmit() {
      const text = this.innerValue;
      const splitted = text.split(",");
      this.added = [...this.added, ...splitted.map(t => t.trim())].filter(
        a => a
      );
      this.innerValue = "";
    },
    removeTag(tag) {
      const aux = this.added.filter(t => t !== tag);
      this.added = [];
      this.added = aux;
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-input-component {
  .input-tag {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    border: 1px solid #928f9890;
    border-radius: 4px;
    padding: 10px;

    span {
      background-color: #d2d0d8;
      border-radius: 4px;
      max-height: 70%;
      cursor: pointer;
    }

    input {
      border-radius: 4px;
      height: 100%;
      min-width: 100px;
      background-color: transparent;
      border: 0;
      outline: none;
    }

    .btn {
      font-weight: 400;
    }
  }
}
</style>
